import Toast from '@/shared/services/toast';
import FileSaver from 'file-saver';
import { flowsApi } from '@/features/bots/services/flows';

class ExportFlow {
  public async exportFlow(botId: string, flowId: string): Promise<void> {
    try {
      const response = await flowsApi.getFlow(botId, flowId);
      response.id = '';
      const save: Blob = new Blob(
        [
          JSON.stringify(response, (key, value) => {
            if (value !== null) {
              return value;
            }
          }),
        ],
        { type: 'application/json;charset=utf-8' },
      );
      FileSaver.saveAs(save, `${response.name}.json`);
    } catch (e) {
      Toast.showError('Failed to export flow');
    }
  }
}

export const exportFlowHelper = new ExportFlow();
